import React, { Component } from "react";
import "./RefrigerationSearch.css";
import { SearchForm } from "./SearchForm";
import { SearchResults } from "./SearchResults";
import queryString from "query-string";
import { navigate } from "@reach/router";
import { FormattedMessage } from "react-intl";
import { parseLang, constructApiUrl, isTermListValid } from "../utils";
import { Helmet } from "react-helmet";
import { CompetencyDescriptions } from "../components/CompetencyDescriptions";
import MunicipalityContext from "../MunicipalityContext";

export class RefrigerationSearch extends Component {

  static contextType = MunicipalityContext;

  initialState = {
    selectedMunicipalities: [],
    selectedOperatingRights: [],
    page: 0,
    pageSize: 10,
    searchText: "",
    sortColumn: "Nimi",
    sortDirection: "asc",
    // these are not reflected in query params
    totalRows: 0,
    searchResults: null,
    searching: false,
    searchError: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.initialState,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);


    // set initial local state from query params
    this.setState(
      {
        selectedMunicipalities: query.m || [],
        selectedOperatingRights: query.o || [],
        page: Number(query.p) || 0,
        searchText: query.q || "",
        sortColumn: query.sc || "Nimi",
        sortDirection: query.sd || "asc",
      },
      () => {
        if (this.isFormValid()) {
          this.fetch();
        }
      }
    );
  }

  resetForm = () => {
    this.setState(this.initialState);
    this.resetQueryString();
  };

  isFormValid = () => {
    return isTermListValid(this.state.searchText) ||
      this.state.selectedOperatingRights.length ||
      this.state.selectedMunicipalities.length;
  };

  buildQueryString = () => {
    return queryString.stringify({
      person: this.state.searchText,
      page: this.state.page,
      pageSize: this.state.pageSize,
      municipality: this.state.selectedMunicipalities,
      operationRight: this.state.selectedOperatingRights,
      order: `${!this.state.sortColumn || this.state.sortDirection === "asc" ? "" : "-"}${this.state.sortColumn
        }`,
    });
  };

  // updates new query parameters to current url
  navigateWithQuery = query => {
    const { location, uri } = this.props;
    const stringified = queryString.stringify({
      ...queryString.parse(location.search),
      ...query,
    });
    navigate(`${uri}?${stringified}`, { replace: true });
  };

  // this is called when user selects municipality from multiselect
  municipalitySelected = nextValues => {
    const queryValues = nextValues.map(value => value.value);
    this.setState({ selectedMunicipalities: queryValues }, () => {
      this.navigateWithQuery({ m: queryValues });
    });
  };

  // this is called when user selects operating right from multiselect
  operatingRightSelected = nextValues => {
    const queryValues = nextValues.map(value => value.value);
    this.setState({ selectedOperatingRights: queryValues }, () => {
      this.navigateWithQuery({ o: queryValues });
    });
  };

  changePage = nextPage => {
    this.setState({ page: nextPage }, () => {
      this.navigateWithQuery({ p: nextPage });
      this.fetch();
    });
  };

  setSearchText = event => {
    const searchText = event.currentTarget.value;
    this.setState({ searchText }, () => {
      this.navigateWithQuery({ q: searchText });
    });
  };

  sortChanged = sortColumn => {
    const sortDirection = this.state.sortDirection === "asc" ? "desc" : "asc";
    if (this.state.sortColumn === sortColumn) {
      this.setState({ sortDirection }, () => {
        this.navigateWithQuery({ sd: sortDirection });
        this.fetch();
      });
    } else {
      this.setState({ sortColumn, sortDirection }, () => {
        this.navigateWithQuery({ sc: sortColumn, sd: sortDirection });
        this.fetch();
      });
    }
  };

  resetQueryString = () => {
    this.navigateWithQuery({
      q: [],
      sd: [],
      sc: [],
      m: [],
      o: [],
      p: [],
    });
  };

  fetch = async setPage => {
    await this.setState(state => ({
      ...state,
      page: Number.isInteger(setPage) ? setPage : state.page,
      searching: !state.searching,
      searchResults: null,
    }));

    if (Number.isInteger(setPage)) this.navigateWithQuery({ p: setPage });

    const apiUrl = process.env.REACT_APP_SEARCH_REFRIGERATION_COMPETENCIES;

    try {
      const query = this.buildQueryString();
      const response = await fetch(constructApiUrl(apiUrl, query));
      const responseJSON = await response.json();
      const { totalRows, results } = responseJSON;
      this.setState({
        searchResults: results,
        totalRows: totalRows,
        searching: false,
        searchError: false,
      });
    } catch (error) {
      this.setState({
        searchResults: [],
        totalRows: 0,
        searching: false,
        searchError: true,
      });
    }
  };

  render() {
    const queryLang = parseLang(this.props.location.search);
    const { location } = this.props;
    const municipalities = this.context;

    return (
      <div className='RefrigerationSearch'>
        <FormattedMessage tagName='h1' id='refrigerationSearch.header' />
        <h2>
          <CompetencyDescriptions locale={queryLang} location={location} />
        </h2>
        <FormattedMessage id='refrigerationSearch.header'>
          {refrigrationTitle => <Helmet title={refrigrationTitle} />}
        </FormattedMessage>

        <SearchForm
          fetch={this.fetch}
          isFormValid={this.isFormValid}
          locale={queryLang}
          searchText={this.state.searchText}
          selectedMunicipalities={this.state.selectedMunicipalities}
          selectedOperatingRights={this.state.selectedOperatingRights}
          updateMunicipalities={this.municipalitySelected}
          updateOperatingRights={this.operatingRightSelected}
          updateSearchText={this.setSearchText}
          searching={this.state.searching}
          resetForm={this.resetForm}
        />
        <SearchResults
          changePage={this.changePage}
          currentPage={this.state.page}
          pageSize={this.state.pageSize}
          results={this.state.searchResults}
          totalRows={this.state.totalRows}
          searching={this.state.searching}
          searchError={this.state.searchError}
          sortColumn={this.state.sortColumn}
          sortDirection={this.state.sortDirection}
          updateSort={this.sortChanged}
          locale={queryLang}
          municipalities={municipalities}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/RefrigerationSearch/RefrigerationSearch.js